import PostalStamp from '../PostalStamp';

/**
 * Ráfaga de fuegos artificiales dentro del marco de PostalStamp — el
 * matasellos de la temporada de fiestas (septiembre-octubre).
 *
 * Por qué este motivo y no otro: hereda el MISMO vocabulario de trazo que
 * el sol de verano al que reemplaza (líneas que irradian desde un centro),
 * así que las dos temporadas se leen como piezas de una misma colección en
 * vez de dos ilustraciones sueltas — pero el significado cambia por
 * completo: del calor a la fiesta.
 *
 * Los rayos se calculan en vez de escribirse a mano: doce ángulos exactos
 * salen siempre bien repartidos, cosa que una lista de coordenadas escrita
 * a ojo nunca garantiza.
 */
const CENTER = { x: 60, y: 58 };

const RAYS = Array.from({ length: 12 }, (_, i) => {
    const angle = (i * 30 * Math.PI) / 180;
    // Largos alternados: una ráfaga pareja se ve como una rueda dentada,
    // no como una explosión.
    const outer = i % 2 === 0 ? 19 : 13;
    return {
        x1: CENTER.x + 6 * Math.cos(angle),
        y1: CENTER.y + 6 * Math.sin(angle),
        x2: CENTER.x + outer * Math.cos(angle),
        y2: CENTER.y + outer * Math.sin(angle),
        long: i % 2 === 0,
    };
});

/** Ráfaga secundaria, más chica y desfasada: una sola explosión centrada
 *  se ve estática; dos chispas alrededor dan la sensación de cielo. */
function Spark({ cx, cy, className }) {
    return (
        <g className={className} stroke="var(--kraft-deep)" strokeWidth="1.5" strokeLinecap="round" style={{ transformOrigin: `${cx}px ${cy}px` }}>
            {Array.from({ length: 6 }, (_, i) => {
                const angle = (i * 60 * Math.PI) / 180;
                return (
                    <line
                        key={i}
                        x1={cx + 2 * Math.cos(angle)}
                        y1={cy + 2 * Math.sin(angle)}
                        x2={cx + 6.5 * Math.cos(angle)}
                        y2={cy + 6.5 * Math.sin(angle)}
                    />
                );
            })}
        </g>
    );
}

export default function FireworksIcon({ className = '' }) {
    return (
        <PostalStamp topText="TEMPORADA ALTA · FIESTAS" className={className}>
            <g className="seasonal-burst">
                {RAYS.map((r, i) => (
                    <line
                        key={i}
                        x1={r.x1}
                        y1={r.y1}
                        x2={r.x2}
                        y2={r.y2}
                        stroke="var(--kraft-deep)"
                        strokeWidth={r.long ? 2.5 : 2}
                        strokeLinecap="round"
                    />
                ))}
                {/* Chispa en la punta de cada rayo largo: es lo que separa un
                    fuego artificial de un simple asterisco. */}
                {RAYS.filter((r) => r.long).map((r, i) => (
                    <circle key={i} cx={r.x2} cy={r.y2} r="1.6" fill="var(--stock-oro)" />
                ))}
                <circle cx={CENTER.x} cy={CENTER.y} r="3" fill="var(--stock-mostaza)" stroke="var(--kraft-deep)" strokeWidth="1.5" />
            </g>

            <Spark cx={40} cy={43} className="seasonal-spark" />
            <Spark cx={81} cy={47} className="seasonal-spark seasonal-spark-late" />
        </PostalStamp>
    );
}
